module.exports = __webpack_public_path__ + "static/assets/f106c7fe1f441cb018c72b2d6ae677e6.svg";